import {IOfferDetail} from "../../../offer/types/IOfferDetail";
import {ISurveyOfferDetails} from "../../types/IBuildSurveyParams";

export const mapOfferDetailsToSurveyOfferDetails = (offer: IOfferDetail | null | undefined): ISurveyOfferDetails | null => {
    if (!offer) {
        return null;
    }

    const rooms = offer.stats?.rooms ?? [];

    return {
        id: offer.id,
        region: {
            id: offer.region.id,
            type: offer.region.type,
            stats: offer.region.stats
                ? {
                      region_type_district: offer.region.stats.region_type_district,
                      region_type_county: offer.region.stats.region_type_county
                  }
                : undefined
        },
        roomsMin: rooms.length > 0 ? Math.min(...rooms) : undefined,
        roomsMax: rooms.length > 0 ? Math.max(...rooms) : undefined,
        priceMax: offer.stats?.ranges_price_max
    };
};
